import React from 'react';
import { protectedRoute } from '@/modules/core/root/protected/route';
import { createRoute } from '@tanstack/react-router';

export const preferencesRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'preferences',
  component: React.lazy(async () => await import('@/app/routes/Preferences')),
  wrapInSuspense: true,
});
